import { ITemplateScope } from "AngularFormly";
import { ListFieldController } from "../listFieldController";

export class TextListFieldTypeController extends ListFieldController {
  static $inject = ["$scope"];

  constructor($scope: ITemplateScope) {
    super($scope);
  }

  editItem(): void {
    super.editItem();
    this.setInitialValue(this.value);
  }
}
